import { useCallback, useEffect, useState } from 'react'

export const CRM_VALUES_VISIBLE_KEY = 'crm_values_visible'
export const DEALS_VALUES_VISIBLE_KEY = 'deals_values_visible'

function readInitialValuesVisible(): boolean {
  const primary = localStorage.getItem(CRM_VALUES_VISIBLE_KEY)
  if (primary !== null) return JSON.parse(primary) as boolean

  const legacy = localStorage.getItem(DEALS_VALUES_VISIBLE_KEY)
  if (legacy !== null) return JSON.parse(legacy) as boolean

  return false
}

/** Preferência global de exibir valores monetários (Dashboard, Deals, etc.). */
export function useCrmValuesVisible() {
  const [valuesVisible, setValuesVisible] = useState(readInitialValuesVisible)

  useEffect(() => {
    localStorage.setItem(CRM_VALUES_VISIBLE_KEY, JSON.stringify(valuesVisible))
  }, [valuesVisible])

  const toggleValuesVisibility = useCallback(() => {
    setValuesVisible((prev) => !prev)
  }, [])

  return { valuesVisible, setValuesVisible, toggleValuesVisibility }
}
